<template>
	<div>
		<el-dialog :visible.sync="show" width="70%" :close-on-click-modal="false" :before-close="closeDialog">
			<div class="adminMessage">管理员信息</div>
			<el-form ref="form" :model="submit_data" label-width="96px">

				<el-row>
					<el-col :span="12">
						<el-form-item label="用户名:">
							<el-input v-model="submit_data.user_name" maxlength="20" minlength="8"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="昵称:">
							<el-input v-model="submit_data.name" maxlength="20" minlength="8"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="密码:">
							<el-input v-model="submit_data.password" type="password"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="重复密码:">
							<el-input v-model="repetition_password" type="password"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="绑定电话:">
							<el-input v-model="submit_data.phone" maxlength="11"></el-input>
						</el-form-item>
					</el-col>

				</el-row>




				<el-form-item label="锁定:">
					<el-switch v-model="submit_data.locking" active-value="1" inactive-value="0"></el-switch>
				</el-form-item>

				<el-form-item label="验证阈值:">
					<el-switch v-model="submit_data.verify" active-value="1" inactive-value="0"></el-switch>
				</el-form-item>



				<template>
					<el-form-item label="角色选择:">
						<div class="juese">
							<el-radio-group v-model="submit_data.admin_role_code" size="mini">
								<el-radio v-for="(value,key) in admin_role_list" :label="value.admin_role_code" border
									style="width:160px;margin-left:1px;margin-bottom:20px;">
									{{value.name}}
								</el-radio>
							</el-radio-group>
						</div>
					</el-form-item>
				</template>


				<el-form-item label="指定用户:">
					<el-input v-for="(item,index) in only_consumer_code_array" v-model="only_consumer_code_array[index].phone" placeholder="请输入手机号码" maxlength="11" style="width: 200px"></el-input>
				</el-form-item>

				<el-form-item>
					<el-button @click="addPhone">增加号码</el-button>
					<el-button @click="delPhone">移除号码</el-button>
				</el-form-item>

				<el-form-item>
<!--					<el-button type="primary" @click="addAdminSubmit">确定</el-button>-->
					<submitBtn @onSubmitDig="onSubmitDig" :data="submit_data" :rules="submit_rules" :url="submit_url" @toJSON="toJSON" :JSON_Boolean="true"></submitBtn>
					<el-button @click="closeDialog">取消</el-button>
				</el-form-item>
			</el-form>






		</el-dialog>



		<editCompanyDialog :isShow="comapny_isShow" :data="company_data"></editCompanyDialog>



	</div>
</template>

<script>
	var _this;
	import editCompanyDialog from '../company/editCompanyDialog.vue';
	export default {
		components: {
			editCompanyDialog
		},

		props: {

			isShow: true,

		},
		//监听父组件传过来的值
		watch: {

			isShow(newData, oldData) {

				_this.show = true;


				_this.adminRoleLists();


			}

		},
		data() {
			return {


				only_consumer_code_array:[{
					phone:''
				}],


				comapny_isShow: false,

				company_data: '',

				// 重复密码
				repetition_password: '',
				checked: '',
				admin_role_list: [],



				admin_role_code: '',

				submit_url:'/system/addAdminSubmit',
				// 添加管理员数据
				submit_data: {
					admin_role_code: '',
					user_name: '',
					password: '',
					name: '',
					phone: '',
					locking: 0,
					verify: 0,
					only_consumer_code_array:''
				},
				// 添加管理员数据验证
				submit_rules: {
					admin_role_code: {
						placeholder: '角色',
						rules: {
							required: true,
							message: '角色信息错误',
							regulation: 'special',
							rulesData: 'table_code'
						}
					},
					user_name: {
						placeholder: '用户名',
						rules: {
							required: false,
							message: '用户名必须为8-20位字母',
							regulation: 'between_str',
							rulesData: [8, 20]
						}
					},
					password: {
						placeholder: '密码',
						rules: {
							required: true,
							message: '密码必须为8-20位',
							regulation: 'between_str',
							rulesData: [8, 20]
						}
					},
					name: {
						placeholder: '名称必须在40字节以内',
						rules: {
							required: true,
							message: '名称必须在40字节以内',
							regulation: 'elt_str',
							rulesData: 40
						}
					},
					phone: {
						placeholder: '手机号码必须为11位',
						rules: {
							required: true,
							message: '手机号码必须为11位',
							regulation: 'eq_str',
							rulesData: 11
						}
					},
					locking: {
						placeholder: '锁定值',
						rules: {
							required: true,
							message: '锁定值错误',
							regulation: 'special',
							rulesData: '0|1'
						}
					},
					verify: {
						placeholder: '验证阈值',
						rules: {
							required: true,
							message: '验证阈值错误',
							regulation: 'special',
							rulesData: '0|1'
						}
					},
				},
				show: false,


			};
		},
		created() {

			_this = this;


		},
		methods: {

			toJSON(){
				var data = [];


				for (var i = 0;i<_this.only_consumer_code_array.length;i++){

					data.push(_this.only_consumer_code_array[i].phone);

				}

				_this.submit_data.only_consumer_code_array = JSON.stringify(data)

			},

			// 增加手机号
			addPhone(){
				_this.only_consumer_code_array.push({
					phone:''
				})
			},

			// 移除手机号
			delPhone(){

				if(_this.only_consumer_code_array.length>0){
					_this.only_consumer_code_array.pop()
				}

			},

			toCompany() {

				_this.comapny_isShow = !_this.comapny_isShow;

				_this.company_data = _this.company_code;

			},


			// 关闭方法
			closeDialog() {
				_this.show = false;

				_this.submit_data = {
					admin_role_code: '',
					user_name: '',
					password: '',
					name: '',
					phone: '',
					locking: 0,
					verify: 0,
					only_consumer_code_array:''
				};

				_this.only_consumer_code_array = [{
					phone:''
				}];

				_this.repetition_password = '';
			},



			onSubmitDig() {



				_this.closeDialog();

				var return_data = {
					page: 1,
					limit: 10,
					admin_role_code: '',
					user_name: '',
					name: '',
					phone: '',
					locking: '',
					status: '',
					verify: '',
				};


				_this.$emit("submit_ok_return", return_data);




			},




			//初始化角色列表
			adminRoleLists() {

				_this.$post(
						"/system/adminRoleLists", {
							page: 1,
							limit: 50
						}
					)
					.then(res => {

						_this.admin_role_list = res.data;

					}).catch((err) => {

					})

			},
		}
	};
</script>
<style scoped>
	.juese {
		width: 70%;
		margin-top: 5px;
	}

	.row-list {

		display: flex;

		flex-direction: row;

		align-items: center;

		justify-content: flex-start;

		flex-wrap: wrap;


	}

	.row-list .el-form-item {

		display: flex;
		flex-direction: row;

		align-items: center;
		justify-content: flex-start;

		width: 50%;


	}

	.row-list .el-form-item .el-input {

		margin-left: 0;

	}

	.adminMessage {
		font-family: Microsoft YaHei;
		font-weight: 600;
		line-height: 21px;
		color: #222;
		margin-bottom: 20px;
		font-size: 18px;
	}
</style>